import * as React from "react";
import classNames from "classnames";
import Label from "./Label";

interface IProps {
	labelText?: string;
	placeholder?: string;
	value?: string | number;
	onChange?: (value?: {}) => void;
	/*onKeyPress?: (e: any) => any;
	onKeyUp?: (value?: any) => void;
	onKeyDown?: (value?: any) => void;*/
	onBlur?: (e: any) => void;
	onFocus?: (e: any) => void;
	name: string;
	id?: string;
	input?: any; // used by redux form
	defaultValue?: string;
	required?: boolean;
	maxlength?: number;
	type?: string;
	addOnBefore?: {};
	addOnAfter?: {};
	className?: string;
	controlClassName?: string;
	disabled?: boolean;
	readOnly?: boolean;
	error?: { hasError: boolean; message: string };
	helpBlock?: {};
}

const TextInput: React.FC<IProps> = ({
	className,
	labelText,
	addOnBefore,
	addOnAfter,
	controlClassName,
	helpBlock,
	...props
}) => {
	return (
		<div className={classNames("form-group", className)}>
			{labelText && (
				<Label required={props.required} htmlFor={props.id || props.name}>
					{labelText}
				</Label>
			)}
			<div className="input-group">
				{addOnBefore && (
					<div className="input-group-prepend">
						<div className="input-group-text">{addOnBefore}</div>
					</div>
				)}
				<input
					{...props}
					id={props.id || props.name}
					type={props.type ? props.type : "text"}
					value={props.value || ""}
					className={classNames(
						"form-control",
						{ "is-invalid": props.error && props.error.hasError },
						controlClassName
					)}
				/>
				{addOnAfter && (
					<div className="input-group-append">
						<div className="input-group-text">{addOnAfter}</div>
					</div>
				)}
			</div>
			{helpBlock && (
				<div className="form-help-block form-text text-muted">{helpBlock}</div>
			)}
			{props.error && (
				<div className="invalid-feedback">{props.error.message}</div>
			)}
		</div>
	);
};

export default TextInput;
